export const ROOM_STATUS = {
  READY: "ready",
  DIRTY: "dirty",
  OCCUPIED: "occupied",
  BLOCKED: "blocked",
};

export const ROOM_CHECKIN = {
  checkIn: 2,
  pendingBooking: 0,
  confirmBooking: 1,
  checkedOut: 3,
  cancelledBooking: 4,
  noShow: 5,
  callNotPicked: 6,
};

export const ROOM_STATUS_BG_COLOR = {
  [ROOM_STATUS.READY]: "#E8FFF3",
  [ROOM_STATUS.DIRTY]: "#FFF8DD",
  [ROOM_STATUS.OCCUPIED]: "#FFF5F8",
  [ROOM_STATUS.BLOCKED]: "#ebeae8",
};

export const ROOM_STATUS_COLOR = {
  [ROOM_STATUS.READY]: "#47BE7D",
  [ROOM_STATUS.DIRTY]: "#E9B500",
  [ROOM_STATUS.OCCUPIED]: "#D9214E",
  [ROOM_STATUS.BLOCKED]: "#ebeae8",
};

export const PAYMENT_MODE = {
  ONLINE: 1,
  CASH: 0,
  ONLINE_AND_CASH: 3,
};

export const PAYMENT_MODE_TEXT = {
  [PAYMENT_MODE.ONLINE]: "Online",
  [PAYMENT_MODE.CASH]: "Pay at hotel",
  [PAYMENT_MODE.ONLINE_AND_CASH]: "Partial Payment",
};

export const USER_ROLE_TEXT = [
  "User Roles",
  "Rrooms Super Admin",
  "Rrooms Admin",
  "Property Super Admin",
  "Property Admin",
  "Manager",
  "Captain",
  "Executive",
];
export const USER_DEG_TEXT = [
  "User Designation",
  "MD",
  "GM",
  "AGM",
  "FOM",
  "SDM",
  "SDC",
  "HK Supervisor",
  "HK Executive",
  "Accounts Manager",
  "Accounts Executive",
  "Store Manager (Kitchen)",
  "Store Incharge",
  "RSOT",
];
export const USER_DEG_TEXT_WITH_ANUM = [
  { name: "MD", value: 1 },
  { name: "GM", value: 2 },
  { name: "AGM", value: 3 },
  { name: "FOM", value: 4 },
  { name: "SDM", value: 5 },
  { name: "SDC", value: 6 },
  { name: "RSOT", value: 13 },
  { name: "HK Supervisor", value: 7 },
  { name: "HK Executive", value: 8 },
  { name: "Accounts Manager", value: 9 },
  { name: "Accounts Executive", value: 10 },
  { name: "Store Manager (Kitchen)", value: 11 },
  { name: "Store Incharge", value: 12 },
];
export const USER_DEG_ENUM = {
  MD: 1,
  GM: 2,
  AGM: 3,
  FOM: 4,
  SDM: 5,
  SDC: 6,
  HKSupervisor: 7,
  HKExecutive: 8,
  AccountsManager: 9,
  AccountsExecutive: 10,
  StoreManager: 11,
  StoreIncharge: 12,
  RSOT: 13,
};
export const USER_ROLE_ENUM = {
  rroomsSuperAdmin: 1,
  rroomsAdmin: 2,
  propertySuperAdmin: 3,
  propertyAdmin: 4,
  manager: 5,
  captain: 6,
  executive: 7,
};

export const TRAVELLER_CHOICE_TEXT = {
  short: 1,
  Corporate: 2,
  FamilyVacation: 3,
  GuaranteedCheckIn: 4,
  GroupCheckIn: 5,
  SoloTraveler: 6,
  PetFriendly: 15,
  PayAtHotel: 16,
};

export const PAYMENT_STATUS = {
  PENDING: 1,
  PARTIAL_PAYMENT: 2,
  FULL_PAYMENT: 3,
};

export const PAYMENT_STATUS_TEXT = {
  [PAYMENT_STATUS.PENDING]: "Confirmed",
  [PAYMENT_STATUS.PARTIAL_PAYMENT]: "Confirmed",
  [PAYMENT_STATUS.FULL_PAYMENT]: "Confirmed",
};

export const DEFAULT_QUERY_KEYS = {
  staleTime: 1800000,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  refetchOnMount: false,
  retry: 0,
};

export const BOOKING_TEXT_SHOW = [
  "Pending",
  "Upcoming",
  "Checked- In",
  "Checked-Out",
  "Cancelled",
  "No-Show",
  // "Call Not picked",
  "CID",
  "Rejected",
  "Pending",
];

export const propertyPolicy = [
  "Unmarried Couples above 18 years allowed.",
  "Unmarried Couples above 18 years not allowed.",
  "Local ID accepted.",
  "Local ID not accepted.",
  "No cancellation charges before 24hrs of hotel check-in And within 15 min of same day.",
  "Only Indian residents & NRIs with Indian ID can check in.",
];

export const paymentModes = ["Select Source", "Bank Transfer", "Cheque", "UPI"];
export const paymentMainModes = ["Offline", "Online"];
export const paymentInvoiceStatus = [
  { id: 0, name: "Pending" },
  { id: 1, name: "Paid" },
  { id: 2, name: "In Review" },
];

export const limitItems = [10, 20, 30, 50, 100, 200];
export const limitItemsBooking = [10, 25, 50, 100, 200];

export const ORDER_STATUS = {
  KOT: 0,
  PROCESS: 1,
  DELIVERED: 2,
  COMPLETE: 3,
  CANCELED: 4,
  ALL: 5,
  NCKOT: 6,
};
export const statusfood = [
  "KOT",
  "In-process",
  "Delivered ",
  "Complete",
  "Cancelled",
];

export const renderTags = [
  { id: 1, name: "NC KOT" },
  { id: 2, name: "Staff" },
  // { id: 3, name: "Table" },
  // { id: 4, name: "Direct" },
];

export const statusfoodColor = [
  "#03a5fc",
  "#094f12",
  "#4f3b09",
  "#b58307",
  "red",
];
// export const PAYMENT_MODES_TEXT = [
//   "N/A",
//   "N/A",
//   "CASH",
//   "CARD",
//   "FOC",
//   "UPI",
//   "PAYLATER",
//   "PREPAID",
// ];
export const PAYMENT_MODES_TEXT = [
  "PREPAID",
  "CASH",
  "CARD",
  "FOC",
  "UPI",
  "PAYLATER",
  "PREPAID",
];

export const ResturantGuestType = [
  "Select Guest Type",
  "MD References",
  "Rooms",
  "Online",
  "Corporate",
  "Walk-In",
  "Staff References",
];

export const banquetPaymentMode = [
  "Cash",
  "Cheque/DD",
  "Cards",
  "IMPS",
  "Bill to Company",
  "Credit to party",
];
export const banquetStatus = [
  {
    id: 0,
    name: "In-Process",
  },
  {
    id: 1,
    name: "Completed",
  },
  {
    id: 2,
    name: "Cancelled",
  },
];
export const resturantStatus = [
  {
    id: 0,
    name: "In-Process",
    color: "primary",
  },
  {
    id: 1,
    name: "Confirm",
    color: "green",
  },
  {
    id: 2,
    name: "In-Kitchen",
    color: "orange",
  },
  {
    id: 3,
    name: "Completed",
    color: "#aa0eb3",
  },
  {
    id: 4,
    name: "Cancelled",
    color: "red",
  },
];
export const PAYMENT_MODES = {
  PREPAID: 1,
  CASH: 2,
  CARD: 3,
  FOC: 4,
  UPI: 5,
  PAYLATER: 6,
  PREPAID: 7,
};

export const PAYMENT_MODE_LABELS = {
  1: "PREPAID",
  2: "CASH",
  3: "CARD",
  4: "FOC",
  5: "UPI",
  6: "PAYLATER",
  7: "PREPAID"
};


export const ROOM_CATEGORY = {
  1: 'STANDARD DOUBLE BED',
  2: 'DELUXE DOUBLE BED',
  3: 'SUITE ROOM',
  5: 'STANDARD SINGLE BED',
  6: 'STANDARD TWIN BED',
  7: 'DELUXE TWIN BED'
};

export const ROOM_CATEGORY_COLOR = {
  1: '#8D33FF',
  2: '#33C1FF',
  3: '#FF5733',
  5: '#33FF57',
  6: '#FFC300',
  7: '#FF33A8'
};

export const ROOM_CATEGORYES = [
  {id: 1, name: 'STANDARD DOUBLE BED', color: '#8D33FF'},
  {id: 2, name: 'DELUXE DOUBLE BED', color: '#FFC300'},
  {id: 3, name: 'SUITE ROOM', color: '#20BF6B'},
  {id: 5, name: 'STANDARD SINGLE BED', color: '#FF5733'},
  {id: 6, name: 'STANDARD TWIN BED', color: '#33C1FF'},
  {id: 7, name: 'DELUXE TWIN BED', color: '#0FB9B1'},
]

export const PROPERTY_CATEGORY = {
  1: 'Economy',
  2: 'Elite',
  3: 'Luxe',
  4: 'Home Stay',
  5: 'Studio'
}
export const PROPERTY_CATEGORY_COLORS = {
  1: '#1FCC75',
  2: '#5069f1',
  3: '#E91E63',
  4: '#FF9800',
  5: '#9C27B0'
}

export const FOOD_PLAN = {
  0: 'EP',
  1: 'CP',
  2: 'AP',
  3: 'MAP',
};

export const KOT_TYPE = [
  { id: 0, name: "Room Service" },
  { id: 1, name: "Dine-In" },
  { id: 2, name: "TakeAway" },
  { id: 3, name: "Staff" },
  { id: 4, name: "NC" },
  { id: 5, name: "Complementary" },
];


export const CancellationPolicies = [
  "Refund will be provided only if cancellation is done 24 hours prior to selected check-in time.",
  "In case booking has been done within 24 hours of check-in time, the refund will be provided only if the booking is cancelled within 15 minutes from the time of booking.",
  "There will be no refund, If you do not show up at the hotel.",
  "There will be no refund if you decide to cancel the booking in the middle of your stay.",
  "If eligible, refund will be initiated, which will reflect in your account within 5-7 business days."
]